if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();

      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(
          this,
          this.initLazySection.bind(this)
        );
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector(
        '.js-inventory-notice'
      );
      this.urgencyMessage = this.querySelector(
        '.js-inventory-urgency'
      );
      this.indicatorBar = this.querySelector(
        '.js-inventory-indicator'
      );
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest(
        '.product-info'
      ).querySelector('variant-picker');

      if (variantPicker) {
        variantPicker.addEventListener(
          'on:variant:change',
          this.handleVariantChange.bind(this)
        );
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector(
        '[type="application/json"]'
      );

      return (
        this.variantInventory ||
        JSON.parse(dataEl.textContent)
      );
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.find(
          (variant) => variant.id === evt.detail.variant.id
        );

        if (!inventory) {
          this.hidden = true;
          return;
        }

        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      if (count === 0 && !available && this.hidden) {
        return;
      }

      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (
        count <= parseInt(this.dataset.thresholdVeryLow, 10)
      ) {
        inventoryLevel = 'very_low';
      } else if (
        count <= parseInt(this.dataset.thresholdLow, 10)
      ) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      const showNotice =
        this.dataset.showNotice === 'always' ||
        (
          this.dataset.showNotice === 'low' &&
          inventoryLevel.includes('low')
        );

      const hideBackordered =
        inventoryLevel === 'backordered' &&
        this.dataset.showNoStockBackordered === 'false';

      if (!showNotice || hideBackordered) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      this.setAttribute(
        'data-inventory-level',
        inventoryLevel
      );

      const readyToShip =
        available &&
        (
          inventoryLevel === 'normal' ||
          inventoryLevel === 'in_stock'
        );

      if (readyToShip) {
        this.inventoryNotice.innerText =
          'Sofort versandfertig, Lieferzeit: 1–3 Werktage';
      } else if (inventoryLevel === 'backordered') {
        this.inventoryNotice.innerText = '';
      } else if (
        inventoryLevel !== 'in_stock' &&
        (
          this.dataset.showCount === 'always' ||
          (
            this.dataset.showCount === 'low' &&
            inventoryLevel.includes('low')
          )
        )
      ) {
        this.inventoryNotice.innerText =
          theme.strings.onlyXLeft.replace(
            '[quantity]',
            count
          );
      } else if (inventoryLevel === 'very_low') {
        this.inventoryNotice.innerText =
          theme.strings.veryLowStock;
      } else if (inventoryLevel === 'low') {
        this.inventoryNotice.innerText =
          theme.strings.lowStock;
      } else if (
        inventoryLevel === 'normal' ||
        inventoryLevel === 'in_stock'
      ) {
        this.inventoryNotice.innerText =
          theme.strings.inStock;
      } else if (inventoryLevel === 'none') {
        this.inventoryNotice.innerText =
          theme.strings.noStock;
      }

      if (this.urgencyMessage) {
        if (readyToShip) {
          this.urgencyMessage.innerHTML = '';
        } else if (inventoryLevel === 'very_low') {
          this.urgencyMessage.innerHTML =
            this.dataset.textVeryLow;
        } else if (inventoryLevel === 'low') {
          this.urgencyMessage.innerHTML =
            this.dataset.textLow;
        } else if (inventoryLevel === 'backordered') {
          this.urgencyMessage.innerHTML =
            this.dataset.textNoStockBackordered;
        } else if (
          inventoryLevel === 'normal' ||
          inventoryLevel === 'in_stock'
        ) {
          this.urgencyMessage.innerHTML =
            this.dataset.textNormal;
        } else if (inventoryLevel === 'none') {
          this.urgencyMessage.innerHTML =
            this.dataset.textNoStock;
        }
      }

      if (this.indicatorBar) {
        this.indicatorBar.hidden = true;
      }
    }
  }

  customElements.define(
    'product-inventory',
    ProductInventory
  );
}